import { createSlice } from '@reduxjs/toolkit';
import update from 'lodash/update';
import { v4 as uuid } from 'uuid';
import { reducerName } from './reducerName';
import { getJobs } from './thunks';
import set from 'lodash/set';

// Declared in its own module to break a load-order cycle; see the file.
export { reducerName };

export const jobsSelectorSlice = createSlice({
  name: reducerName,
  initialState: { jobs: {}, jobsProcessingKey: uuid() },
  reducers: {
    updateJob: (state, { payload: { job } }) => {
      update(state, `jobs.${job.id}`, (c = {}) => ({ ...c, ...job }));
    },
    /* `name` heads the notice when the job finishes. Anything else given is kept with the
       job: `statusUrl` (see getJobs), and whatever a page needs to know a job is its own,
       such as a cohort's id. */
    startWatchingJob: (state, { payload: { jobId, name = '', ...extra } }) => {
      set(state, `jobs.${jobId}`, { ...extra, id: jobId, status: 'pending', name });
      state.jobsProcessingKey = uuid();
    },
  },
  extraReducers(builder) {
    const fulfill = (funcName, cb) => builder.addCase(funcName.fulfilled, cb);
    fulfill(getJobs, (state, { payload: { continueChecking, jobs } }) => {
      state.jobs = jobs;
      state.jobsProcessingKey = continueChecking ? uuid() : state.jobsProcessingKey;
    });
  },
});

export const { updateJob, startWatchingJob } = jobsSelectorSlice.actions;
export default jobsSelectorSlice.reducer;
